import React, { Component } from 'react';
import { Grid, Button, Typography, CircularProgress, Divider, Box, Hidden } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router'
import { Delivery } from '../../api/models/QuotedData';
import { OrderSheetData } from '../../api/models/OrderSheetData';
import StripePaymentForm from './StripePaymentForm';
import { PaymentCard } from '../../api/models/OrderData';
import { ArrowBack } from '@material-ui/icons';

type Props = {
    goNext: () => void,
    quotedOrder: Delivery,
    finalizeOrder: (orderId: number) => void,
    currentOrderId: number,
    orderSheet: OrderSheetData,
    getPaymentIntentBusy: boolean,
    paymentIntentSecret: string | null,
    paymentCards: PaymentCard[] | null
} & RouteComponentProps<any>

class Payment extends Component<Props> {

    render() {
        return (
            <div>
                <Grid container style={{ minHeight: '220px' }} >
                    <Grid item container justify="space-between" sm={5}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h3">Order details</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'left' }}>
                            <Typography variant="subtitle1">ORDER SHEET NAME:</Typography>
                            <div>
                                <div style={{ display: 'inline-block' }} ><Typography variant="body2">{this.props.orderSheet.name}</Typography></div>
                            </div>
                        </Grid>

                        <Grid item xs={12} sm={6} >
                            <Typography variant="subtitle1">TOTAL PRICE</Typography>
                            <Typography variant="h3">{this.props.quotedOrder.currency}&nbsp;{this.props.quotedOrder.finalPrice}</Typography>
                        </Grid>

                        <Grid item style={{ alignSelf: "flex-end" }} xs={12} sm={12}>
                            <Box p={1}><Button variant="outlined" color="primary" onClick={() => this.props.history.push('/Search')} style={{ width: '100%' }}><ArrowBack />&nbsp;&nbsp;&nbsp;Edit order sheet</Button></Box>
                        </Grid>

                    </Grid>
                    <Hidden xsDown>
                        <Grid item sm={1} style={{ position: 'relative' }}>
                            <Divider style={{ position: 'absolute', left: "50%" }} orientation="vertical" />
                        </Grid>
                    </Hidden>
                    <Grid item container sm={6} style={{ width: '100%' }}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h3">Payment details</Typography>
                        </Grid>
                        {this.props.getPaymentIntentBusy ?
                            <Grid style={{ alignSelf: "baseline", textAlign: "center" }} item sm={12}>
                                <CircularProgress size={75} />
                            </Grid>
                            :
                            <>
                                <Grid item sm={12}>
                                    <StripePaymentForm
                                        clientSecret={this.props.paymentIntentSecret}
                                        paymentCards={this.props.paymentCards}
                                        currency={this.props.quotedOrder.currency}
                                        finalPrice={this.props.quotedOrder.finalPrice}
                                        onSuccess={() => this.props.goNext()}
                                    />
                                </Grid>
                            </>
                        }
                    </Grid>

                </Grid>
            </div>
        )
    }
}

export default withRouter(Payment);